import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  ElementRef
} from '@angular/core';

import { UserService } from '../services/user.service';
import { takeLast } from 'rxjs/operators';

@Directive({
  selector: '[appShowAuth]'
})
export class ShowAuthDirective implements OnInit {
  constructor(
    private templateRef: TemplateRef<any>,
    private userService: UserService,
    private viewContainer: ViewContainerRef
  ) { }

  condition: boolean;

  ngOnInit() {
    this.userService.isAuthenticated.subscribe(
      (isAuthenticated) => {
        //console.log('isAuthenticated', isAuthenticated);
        if (isAuthenticated && this.condition || !isAuthenticated && !this.condition) {
          // console.log('con len', this.viewContainer.length);
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
          this.viewContainer.clear();
        }
      }
    );
  }

  @Input() set appShowAuth(condition: boolean) {
    this.condition = condition;
  }

}
